import { render } from "./DetailProductSlider.vue?vue&type=template&id=2dcaa359"
import script from "./DetailProductSlider.vue?vue&type=script&lang=js"
export * from "./DetailProductSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__